import React from "react";
import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";
import classNames from "classnames";
import PropTypes from "prop-types";

import "./Toast.scss";

const Toast = ({
  isShow,
  set = null,
  timeout = 6000,
  className,
  children,
  isUnmountOnExit = false,
  ...rest
}) => {
  const classes = getClassName(rest);
  const {
    small,
    large,
    xl,
    error,
    info,
    success,
    disableNewLine,
    withPadding,
    noBackground,
    ...props
  } = rest;

  if (isShow && set) {
    setTimeout(() => {
      set(null);
    }, timeout + 500);
  }
  //if isShow transferred as string, convert to boolean
  return (
    <AnimationContainer
      animationOn={!!isShow}
      animationClassName={"toast-animation"}
      containerElementClassName="toast-container"
      timeout={timeout}
      isUnmountOnExit={isUnmountOnExit}
    >
      <div className={classes}>{children}</div>
    </AnimationContainer>
  );
};

Toast.propTypes = {
  small: PropTypes.bool,
  large: PropTypes.bool,
  xl: PropTypes.bool,
  error: PropTypes.bool,
  success: PropTypes.bool,
  info: PropTypes.bool,
  disableNewLine: PropTypes.bool,
  noBackground: PropTypes.bool,
};

function getClassName(props) {
  const classes = ["jm-toast"];
  if (props.className) classes.push(props.className);
  if (props.small) classes.push("small-toast");
  if (props.large) classes.push("large-toast");
  if (props.xl) classes.push("xl-toast");
  if (props.info) classes.push("info-toast");
  if (props.success) classes.push("success-toast");
  if (props.error) classes.push("error-toast");
  if (props.noBackground) classes.push("toast-without-background");
  if (props.disableNewLine) classes.push("disable-new-line");
  if (props.withPadding) classes.push("toast-with-padding");
  return classNames(classes);
}
export default Toast;
